import type { ReactNode } from 'react';
import { useTranslations } from 'next-intl';
import { Ui } from '@silvertours/front-shared';
import {
  ContactIcon,
  HelpIcon,
  PhoneInfoPopoverWrapper,
  ContactIconButton,
} from './SupportPopoverButton.styles';

type Props = {
  popupContent: ReactNode;
  /** `help` shows a question mark instead of the speech bubble. */
  icon?: 'contact' | 'help';
};

const SupportPopoverButton = ({ popupContent, icon = 'contact' }: Props) => {
  const t = useTranslations('features.navigationLegacy.navigation');
  return (
    <PhoneInfoPopoverWrapper>
      <Ui.Popover
        button={{
          as: ContactIconButton,
          icon: icon === 'help' ? <HelpIcon /> : <ContactIcon />,
          'aria-label': t('header.contact'),
        }}
      >
        <Ui.PopoverPanel>
          <Ui.PanelContentWrapper
            width="14rem"
            widthMd="21.875rem"
            padding="1.5rem 0 0 0"
          >
            {popupContent}
          </Ui.PanelContentWrapper>
        </Ui.PopoverPanel>
      </Ui.Popover>
    </PhoneInfoPopoverWrapper>
  );
};

export { SupportPopoverButton };
